import React from 'react'

export const LockIcon = (props) => (
    <svg style={props.style} width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.2314 6.35547H2.71947C2.0479 6.35547 1.50348 7.00625 1.50348 7.80903V13.6233C1.50348 14.426 2.0479 15.0768 2.71947 15.0768H11.2314C11.903 15.0768 12.4474 14.426 12.4474 13.6233V7.80903C12.4474 7.00625 11.903 6.35547 11.2314 6.35547Z" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
        <path d="M3.32751 3.44792C3.32751 2.86965 3.51968 2.31508 3.86175 1.90618C4.20381 1.49729 4.66775 1.26758 5.15151 1.26758H8.79949C9.28324 1.26758 9.74718 1.49729 10.0892 1.90618C10.4313 2.31508 10.6235 2.86965 10.6235 3.44792V6.35503H3.32751V3.44792Z" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
)




